import { render, staticRenderFns } from "./HomePC.vue?vue&type=template&id=73109d56&"
import script from "./HomePC.vue?vue&type=script&lang=js&"
export * from "./HomePC.vue?vue&type=script&lang=js&"
import style0 from "./HomePC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HomePC.vue"
export default component.exports